import { EpiPage } from '@api/types';
import { Helmet } from 'react-helmet-async';

export type MetaProps = {
  page?: EpiPage;
};

export const Meta = ({ page = {} }: MetaProps) => {
  const {
    url,
    seoTitle,
    seoKeywords,
    seoDescription,
    seoImage,
    metaDescription,
    name,
    language,
    ogDescription,
    displayName,
    ogImage,
    ogType,
    twitterCard,
  } = page;
  return (
    <Helmet>
      <title>{displayName || seoTitle || name}</title>
      {metaDescription && <meta name='description' content={metaDescription} />}
      {seoKeywords && <meta name='keywords' content={seoKeywords} />}
      {url && <link rel='canonical' href={url} />}
      <link rel='icon' href='/favicon.ico' />
      {language && <meta property='og:locale' content={language?.name} />}
      {url && <meta property='og:url' content={url} />}
      {seoTitle && <meta property='og:title' content={seoTitle} />}
      {ogImage && <meta property='og:image' content={ogImage?.url} />}
      {ogDescription && <meta property='og:description' content={ogDescription} />}
      {ogType && <meta property='og:type' content={ogType} />}

      {twitterCard && <meta name='twitter:card' content={twitterCard} />}
      {seoTitle && <meta name='twitter:title' content={seoTitle} />}
      {seoDescription && <meta name='twitter:description' content={seoDescription} />}
      {seoImage && <meta name='twitter:image' content={seoImage?.url} />}
    </Helmet>
  );
};
